import {
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { ViewPath } from '../../constants/ViewPath';
import {
  MultipleMenuItemComponent,
  MultipleMenuSection,
} from './multiple-menu-item/multiple-menu-item.component';
import { Subject } from 'rxjs';
import { feature } from '../../utils/FeaturesController';
import { ResponsiveService } from '../../services/responsive.service';
import { HostListener } from '@angular/core';
import { UserService } from '../../services/user.service';
import { MenuTriggerComponent } from './menu-trigger/menu-trigger.component';
import { MenuItemComponent } from './menu-item/menu-item.component';
import { CommonModule } from '@angular/common';
import { GoDirective } from '../../directives/go.directive';
import { ReferenceService } from '../../services/onboarding.service';
//import { MenuItem } from '../../types/menu.types';
import {
  MenuInterface,
  MenuItemInterface,
  MenuMultipleOption,
  MenuOption,
  MenuService,
} from '../../services/menu.service';
import { IMenuComponent } from '../../interfaces/IMenuComponent';
import { PermissionsEnum } from '../../enums/PermissionsEnum';
import { MatIconModule } from '@angular/material/icon';
import { BackofficeFeedbackService } from '../../services/backoffice-feedback.service';
import { SectionService } from '../../services/section.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MenuTriggerComponent,
    MenuItemComponent,
    MultipleMenuItemComponent,
    CommonModule,
    GoDirective,
    MatIconModule,
  ],
})
export class MenuComponent implements OnInit, MenuInterface, IMenuComponent {
  //--
  userS = inject(UserService);
  responsiveS = inject(ResponsiveService);
  menuS = inject(MenuService);
  feedbackS = inject(BackofficeFeedbackService);
  sectionS = inject(SectionService);
  v = ViewPath;
  isPhone = this.responsiveS.isPhone();

  // Montamos los puntos de menu segun los permisos y roles del usuario
  userPermissions = this.userS.permisssions;

  /** DASHBOARD */
  panel = new MenuOption(
    'dashboard',
    'Dashboard',
    'Dashboard',
    'dashboard',
    this.v.backofficeDashboard,
    [PermissionsEnum.BACKOFFICE_READ_DASHBOARD],
    [this.v.backofficeDashboard],
  );

  /** CLIENTES */
  clients = new MenuOption(
    'clients',
    'Clientes EINA',
    'Clientes EINA',
    'contacts',
    this.v.clients,
    [PermissionsEnum.CLIENT_READ_LIST],
    [this.v.clients],
    undefined,
    'onboarding-client',
  );

  billingCharges = new MenuOption(
    'billing-charges',
    'Pre Facturas',
    'Pre Facturas',
    'receipt_long',
    this.v.billingCharges,
    [PermissionsEnum.INVOICE_READ_LIST],
    [this.v.billingCharges],
    undefined,
    'onboarding-client',
  );
  companiesContacts = new MenuOption(
    'siniwin-contacts',
    'Contactos',
    'Contactos',
    'people_outline',
    this.v.companiesContacts,
    [PermissionsEnum.EINA_READ_CONTACTS],
    [this.v.companiesContacts],
  );
  calls = new MenuOption(
    'calls',
    'Historial de llamadas',
    'Historial de llamadas',
    'query_builder',
    this.v.historyCalls,
    [PermissionsEnum.COMERCIAL_CALLS],
    [this.v.historyCalls],
  );

  commercialCalculator = new MenuOption(
    'commercial-calculator',
    'Calculadora Comercial',
    'Calculadora Comercial',
    'calculate',
    this.v.commercialCalculator,
    [PermissionsEnum.COMMERCIAL_USE_CALCULATOR],
    [this.v.commercialCalculator],
  );

  users = new MenuOption(
    'users',
    'Usuarios',
    'Usuarios',
    'contacts_product',
    this.v.users,
    [PermissionsEnum.USER_READ_LIST],
    [this.v.users],
    undefined,
    'onboarding-client',
  );

  modules = new MenuOption(
    'modules',
    'Módulos/Integraciones',
    'Módulos/Integraciones',
    'webhook',
    this.v.modules,
    [PermissionsEnum.MODULE_READ_LIST],
    [this.v.modules],
    undefined,
    'onboarding-client',
  );

  /** MONITORIZACIÓN */
  internalLogs = new MenuOption(
    'internal-logs',
    'Logs Internos',
    'Logs Internos',
    'history',
    this.v.internalLogs,
    [PermissionsEnum.LOG_READ_INTERNAL],
    [this.v.internalLogs],
  );

  einaLogs = new MenuOption(
    'eina-logs',
    'Logs de Eina',
    'Logs de Eina',
    'chronic',
    this.v.einaLogs,
    [PermissionsEnum.LOG_READ_EINA],
    [this.v.einaLogs],
  );

  systemLogs = new MenuOption(
    'system-logs',
    'Logs de Sistema',
    'Logs del Sistema',
    'manage_history',
    this.v.systemLogs,
    [PermissionsEnum.LOG_READ_SYSTEM],
    [this.v.systemLogs],
  );

  errorLogs = new MenuOption(
    'error-logs',
    'Logs de Error',
    'Logs de Error (Sentry)',
    'bug_report',
    this.v.errorLogs,
    [PermissionsEnum.LOG_READ_ERROR],
    [this.v.errorLogs],
  );

  feedback = new MenuOption(
    'feedback',
    'Encuestas',
    'Encuestas',
    'rate_review',
    this.v.feedback,
    [],
    [this.v.feedback, this.v.feedbackDetails],
  );

  /** DEVELOPER */
  importStatus = new MenuOption(
    'import-status',
    'Estado de Importaciones',
    'Estado de Importaciones',
    'sync',
    this.v.importStatus,
    [PermissionsEnum.IMPORT_READ_STATUS],
    [this.v.importStatus],
  );

  endpointTimings = new MenuOption(
    'endpoint-timings',
    'Rendimiento',
    'Rendimiento',
    'speed',
    this.v.endpointTimings,
    [PermissionsEnum.BACKOFFICE_READ_ENDPOINT_TIMINGS],
    [this.v.endpointTimings],
  );
  apiTokens = new MenuOption(
    'company-tokens',
    'API Tokens',
    'API Tokens',
    'api',
    this.v.companyTokens,
    [PermissionsEnum.BACKOFFICE_READ_ENDPOINT_TIMINGS],
    [this.v.companyTokens],
  );

  developerBranch = new MenuOption(
    'developer-branch',
    'Ramas',
    'Ramas',
    'account_tree',
    this.v.developerBranch,
    [PermissionsEnum.DEVELOPER_READ_BRANCHES],
    [this.v.developerBranch],
  );

  developerDatabase = new MenuOption(
    'developer-database',
    'Base de datos',
    'Base de datos',
    'storage',
    this.v.developerDatabase,
    [PermissionsEnum.DEVELOPER_READ_DATABASE],
    [this.v.developerDatabase],
  );

  siniwinClients = new MenuOption(
    'siniwin-clients',
    'Clientes',
    'Clientes',
    'contacts',
    this.v.siniwinClients,
    [PermissionsEnum.SINIWIN_READ_CLIENTS],
    [this.v.siniwinClients],
  );

  materClients = new MenuOption(
    'master-clients',
    'Clientes',
    'Clientes',
    'contacts',
    this.v.masterClients,
    [PermissionsEnum.MASTER_CLIENTS_READ_LIST],
    [this.v.masterClients],
  );

  BHotline = new MenuMultipleOption(
    'clientes',
    'Hotline',
    'Gestión de clientes',
    [this.materClients, this.companiesContacts, this.calls],
    this.v.clients,
    [PermissionsEnum.CLIENT_READ_LIST],
  );

  BClientes = new MenuMultipleOption(
    'clientes',
    'Clientes',
    'Gestión de clientes y configuración',
    [this.clients, this.users, this.modules, this.billingCharges],
    this.v.clients,
    [PermissionsEnum.CLIENT_READ_LIST],
  );

  BMonitoring = new MenuMultipleOption(
    'monitoring',
    'Monitorización',
    'Logs y feedback',
    [this.internalLogs, this.einaLogs, this.systemLogs, this.errorLogs],
    this.v.internalLogs,
    [PermissionsEnum.LOG_READ_INTERNAL],
  );

  BCommercial = new MenuMultipleOption(
    'commercial',
    'Comercial',
    'Apartado comercial',
    [this.commercialCalculator, this.feedback],
    this.v.commercialCalculator,
    [PermissionsEnum.COMMERCIAL_USE_CALCULATOR],
  );

  BDeveloper = new MenuMultipleOption(
    'developer',
    'Developer',
    'Herramientas técnicas',
    [
      this.importStatus,
      this.endpointTimings,
      this.apiTokens,
      this.developerBranch,
      this.developerDatabase,
    ],
    this.v.importStatus,
    [
      PermissionsEnum.IMPORT_READ_STATUS,
      PermissionsEnum.BACKOFFICE_READ_ENDPOINT_TIMINGS,
      PermissionsEnum.DEVELOPER_READ_BRANCHES,
      PermissionsEnum.DEVELOPER_READ_DATABASE,
    ],
  );

  menuItems: MenuItemInterface[] = [
    this.panel,
    this.BHotline,
    this.BClientes,
    this.BMonitoring,
    this.BCommercial,
    this.BDeveloper,
  ];

  currentDashboard: string = 'default';

  @Input() isDesktop = true;
  @Input() drawer?: MatDrawer;
  @Input() refService?: ReferenceService;
  @ViewChild('menu') menu!: ElementRef<HTMLDivElement>;
  @Output() onclicktrigger: EventEmitter<any> = new EventEmitter<any>();

  features = feature;
  opened = false;
  enter = false;
  exit = false;
  lockmenu = false;
  mms = MultipleMenuSection;
  onStartOnboardingSection: Subject<any> = new Subject();

  constructor() {
    this.feedbackS.loadUnreadCount().subscribe((val) => {
      this.feedbackS.unreadCount.set(val.count);
    });
    this.responsiveS.onResize.subscribe((val) => {
      this.isPhone = this.responsiveS.isPhone();
    });
  }

  // Usar el mismo componente para ambos casos
  get menuClass() {
    return {
      'desktop-menu': this.isDesktop,
      'mobile-menu': !this.isDesktop,
      opened: this.opened,
    };
  }

  afterGoTo() {
    if (this.isDesktop) {
      if (!this.lockmenu) {
        this.opened = false;
      }
    } else {
      if (this.drawer) {
        this.drawer.close();
        this.opened = false;
      }
    }
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    // Si no es desktop, no hacemos nada
    if (!this.isDesktop) return;

    const clickedInside = this.menu?.nativeElement.contains(event.target as Node);

    if (!clickedInside && !this.lockmenu) {
      this.close();
    }
  }
  get hiddenToUser() {
    return this.responsiveS.isPhone();
  }

  ngOnInit(): void {
    /** When the onboarding inits, aut oassigns itself to the service input parameter.
     *  Like this, is possible to call this component inside the service of 'refService',
     */

    const stored = localStorage.getItem('menuOpened');
    if (stored !== null) {
      this.opened = stored === 'true';
    }
    const storedLocked = localStorage.getItem('menuLocked');
    if (storedLocked !== null) {
      this.lockmenu = JSON.parse(storedLocked);
    }
    if (this.refService) {
      this.refService.menuComponent = this;
    }

    this.feedbackS.loadUnreadCount();
  }

  onMouseEnterComponent() {
    if (this.isDesktop) {
      if (!this.lockmenu) {
        this.enter = true;
        this.exit = false;
        setTimeout(() => {
          if (!this.exit) {
            if (this.isDesktop) {
              this.open();
            }
          }
        }, 350);
      }
    }
  }

  onMouseLeaveComponent() {
    if (this.isDesktop) {
      if (!this.lockmenu) {
        this.exit = true;
        this.enter = false;
        if (this.isDesktop) {
          this.close();
        }
      }
    }
  }

  open() {
    this.opened = true;
    localStorage.setItem('menuOpened', 'true');
  }

  close() {
    this.opened = false;
    localStorage.setItem('menuOpened', 'false');
    if (!this.drawer) {
      this.lockmenu = false;
      localStorage.setItem('menuLocked', 'false');
    }
  }

  toggle() {
    if (this.drawer) {
      if (this.drawer.opened) {
        this.drawer.close();
        this.opened = false;
      } else {
        this.drawer.open();
        this.opened = true;
      }
      localStorage.setItem('menuOpened', JSON.stringify(this.opened));
    } else {
      this.lockmenu = !this.lockmenu;
      this.opened = !this.opened;
      localStorage.setItem('menuOpened', JSON.stringify(this.opened));
      localStorage.setItem('menuLocked', JSON.stringify(this.lockmenu));
    }
  }

  toggleTo(opened: boolean) {
    this.opened = opened;
    localStorage.setItem('menuOpened', JSON.stringify(opened));
    localStorage.setItem('menuLocked', JSON.stringify(opened));
    if (this.drawer) {
      if (!opened) {
        this.drawer.close();
        this.opened = false;
      } else {
        this.drawer.open();
        this.opened = true;
      }
    } else {
      this.lockmenu = opened;
      this.opened = opened;
    }
  }

  openAllDropdowns() {
    this.onStartOnboardingSection.next(true);
  }
}
